import React from 'react';

interface SummaryItemProps {
  label: string;
  value: string;
  valueColor?: string;
}

export const SummaryItem: React.FC<SummaryItemProps> = ({
  label,
  value,
  valueColor = 'text-gray-700',
}) => (
  <p className='flex items-center gap-2 overflow-hidden'>
    <strong className='text-gray-900 shrink-0'>{label}:</strong>
    <span className={`${valueColor} font-medium truncate`}>
      {value || 'N/A'}
    </span>
  </p>
);

interface MoodBadgeProps {
  emoji?: string;
  description?: string;
}

export const MoodBadge: React.FC<MoodBadgeProps> = ({
  emoji = '🙂',
  description = 'N/A',
}) => (
  <p className='col-span-2 flex items-center gap-2 overflow-hidden'>
    <strong className='text-gray-900 shrink-0'>Estado de ánimo:</strong>
    <span className='flex items-center gap-1.5 px-2 py-0.5 bg-orange-50 rounded-full text-[11px] font-bold text-orange-600 border border-orange-100 truncate'>
      {emoji} {description}
    </span>
  </p>
);

interface ApproachSectionProps {
  content: string;
}

export const ApproachSection: React.FC<ApproachSectionProps> = ({
  content,
}) => (
  <div className='col-span-2 border-t border-gray-100 pt-3 mt-1'>
    <p className='text-xs text-gray-700 leading-relaxed italic bg-blue-50/50 p-2 rounded-lg border-l-2 border-blue-400 break-words'>
      <strong className='not-italic text-blue-700 block mb-1'>Abordaje:</strong>
      {content || 'N/A'}
    </p>
  </div>
);
